import type { User } from '@/types/user';
import { UserRoleBadge } from './user-role-badge';
import { UserStatusBadge } from './user-status-badge';

interface UserRowProps {
  user: User;
  onEdit: (user: User) => void;
  onToggleStatus: (user: User) => void;
  isUpdating: boolean;
}

export function UserRow({ user, onEdit, onToggleStatus, isUpdating }: UserRowProps) {
  return (
    <tr className="border-b border-gray-700 last:border-b-0 hover:bg-gray-700/50">
      <td className="px-4 py-3">
        <div>
          <p className="font-medium">{user.firstName} {user.lastName}</p>
          <p className="text-sm text-gray-400">{user.email}</p>
        </div>
      </td>
      <td className="px-4 py-3">
        <UserRoleBadge role={user.role} />
      </td>
      <td className="px-4 py-3">
        <UserStatusBadge isActive={user.isActive} />
      </td>
      <td className="px-4 py-3 text-right">
        <div className="flex items-center justify-end gap-2">
          <button
            onClick={() => onEdit(user)}
            className="px-3 py-1.5 text-sm bg-gray-700 hover:bg-gray-600 rounded transition-colors"
          >
            Edit
          </button>
          <button
            onClick={() => onToggleStatus(user)}
            disabled={isUpdating}
            className={`px-3 py-1.5 text-sm rounded transition-colors disabled:opacity-50 ${
              user.isActive
                ? 'bg-red-600/20 text-red-400 hover:bg-red-600/30'
                : 'bg-green-600/20 text-green-400 hover:bg-green-600/30'
            }`}
          >
            {user.isActive ? 'Deactivate' : 'Activate'}
          </button>
        </div>
      </td>
    </tr>
  );
}
